// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jx-1";
export var stateContainer = "_jx-0";